/**
 * Cabin minimum-stay helpers.
 *
 * The seasonal mid-week exception (Aug–Sep 2026) has been removed.
 * The cabin now enforces its standard base minimum (set in PriceLabs/settings)
 * for all stays. Function signatures are preserved for callers.
 */

export const MIDWEEK_EXCEPTION_MIN_NIGHTS = 3; // kept for import compat, no longer applied

/** Always returns false — the mid-week exception is no longer active. */
export function isMidweekException(_checkIn: Date | string, _nights: number): boolean {
  return false;
}

/**
 * The minimum nights that apply to a specific stay. Returns the base minimum.
 * Use this for authoritative server guards.
 */
export function getApplicableMinNights(
  _checkIn: Date | string,
  _nights: number,
  baseMinNights: number,
): number {
  return Math.max(1, baseMinNights);
}

/**
 * The smallest number of nights bookable for a given check-in date.
 * Used by the date picker to grey out too-short checkouts.
 */
export function getCheckInMinNights(
  _checkIn: Date | string,
  baseMinNights: number,
): number {
  return Math.max(1, baseMinNights);
}

/** Always returns [] — the mid-week exception is no longer active. */
export function midweekWindowsByProximity(
  _anchor: Date | string,
): Array<{ checkIn: string; checkOut: string }> {
  return [];
}
